<template>
  <!--视频遮罩层-->
  <div class="home_page_cover" v-show="showCover">
    <!--视频介绍-->
    <div class="video_show_window" v-show="showVideo">
      <div class="close_btn" @click="closeWindowCover"></div>
      <video ref="videoEl" :src=videoSrc controls="controls"></video>
    </div>
    <!--教师试用-->
    <div class="try_window" v-show="showTeacherTry">
      <div class="window_title"><span>树鱼教师网页端登录</span><img @click="closeWindowCover"
                                                           src="../assets/images/teacher_try_close_btn.png"/></div>
      <div class="window_content">
        <p>登录网址：https://zhishi.superfishai.com</p>
        <p>请联系树鱼客服人员开通试用账号：</p>
        <img src="../assets/images/wechat_server.png"/>
        <div class="teacher_try_link" @click="gotoZhishi">点击跳转登录网页</div>
      </div>
    </div>
    <!--学生试用-->
    <div class="try_window" v-show="showStudentTry">
      <div class="window_title"><span>树鱼学生端APP下载</span><img @click="closeWindowCover"
                                                            src="../assets/images/teacher_try_close_btn.png"/></div>
      <div class="window_content student">
        <div>
          <p>请联系树鱼客服人员<br/>开通试用账号：</p>
          <img src="../assets/images/wechat_server.png">
        </div>
        <div>
          <p>扫码下载</p>
          <img src="../assets/images/shuyu_App_QR_Code.jpg">
        </div>
      </div>
    </div>
    <!--口语学生试用-->
    <div class="try_window" v-show="showOralStudentTry">
      <div class="window_title"><span>大鱼学生端APP下载</span><img @click="closeWindowCover"
                                                            src="../assets/images/teacher_try_close_btn.png"/></div>
      <div class="window_content student">
        <div>
          <p>请联系树鱼客服人员<br/>开通试用账号：</p>
          <img src="../assets/images/wechat_server.png">
        </div>
        <div>
          <p>扫码下载</p>
          <img src="../assets/images/dayu_App_QR_Code.jpg">
        </div>
      </div>
    </div>
    <!--秀一哈试用-->
    <div class="try_window" v-show="showShowTry">
      <div class="window_title"><span>秀一哈APP下载</span><img @click="closeWindowCover"
                                                            src="../assets/images/teacher_try_close_btn.png"/></div>
      <div class="window_content student">
        <div>
          <p>请联系树鱼客服人员<br/>参与活动：</p>
          <img src="../assets/images/wechat_server.png">
        </div>
        <div>
          <p>扫码下载</p>
          <img src="../assets/images/xiu_App_QR_Code.png">
        </div>
      </div>
    </div>
    <!--树鱼AI试用-->
    <div class="try_window mandarin" v-show="showShuyuAITry">
        <img @click="closeWindowCover" src="../assets/images/teacher_try_close_btn.png"/>
        <h1>树鱼AI</h1>
        <h2>普通话·缅甸语·越南语</h2>
        <p>用美丽语言 拉近你我距离</p>
        <div class="shuyuAI_download">
          <div class="shuyuAI_download_left">
            <div class="shuyuAI_download_btn"><img src="../assets/images/android_icon.png"/>安卓下载</div>
            <div class="shuyuAI_download_btn"><img src="../assets/images/apple_icon.png"/>苹果下载</div>
          </div>
          <div class="shuyuAI_QR_code"><img src="../assets/images/shuyuAI_QR_Code.png"/></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cover',
  props: {
    showCover: Boolean,
    showVideo: Boolean,
    showTeacherTry: Boolean,
    showStudentTry: Boolean,
    showOralStudentTry: Boolean,
    showShowTry: Boolean,
    showShuyuAITry: Boolean,
    videoSrc: String
  },
  methods: {
    gotoZhishi () {
      window.open('https://zhishi.superfishai.com', '_blank')
    },
    closeWindowCover () {
      document.getElementsByTagName('video')[0].pause()
      this.$emit('closeWindowCover')
    }
  }
}
</script>

<style scoped>
.home_page_cover{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgba(0,0,0,0.8);
}
.video_show_window>div{
  width: 6vw;
  height: 6vw;
  background-image: url("../assets/images/close_icon.png");
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  right: 0;
  transition: all .3s ease;
}
.video_show_window>div:hover{
  width: 10vw;
  height: 10vw;
  transition: all .3s ease;
}
.video_show_window>video{
  width: 80vw;
  height: 80vh;
  margin: 10vh 10vw;
}
.try_window{
  width: 50vw;
  height: 32vw;
  text-align: center;
  background: white;
  margin: 20vh auto;
}
.window_title{
  height: 6vw;
  font-size: 2vw;
  line-height: 6vw;
  color: white;
  background: url("../assets/images/window_title_background.png");
  background-size: 100% 100%;
}
.window_title>img{
  width: 3vw;
  position: relative;
  left: 12vw;
}
.window_title>img:hover{
  cursor: pointer;
  transform: rotate(180deg);
  transition: all .3s ease;
}
.window_content>p{
  padding-top: 3vw;
  margin-bottom: 0;
  font-size: 1.4vw;
}
.window_content>img{
  width: 6vw;
  height: 6vw;
  margin: 2vw auto;
}
.teacher_try_link{
  width: 10vw;
  height: 3.6vw;
  line-height: 3.6vw;
  font-size: 1vw;
  color: white;
  background: #568af4;
  margin: 0 auto;
  overflow: hidden;
}
.teacher_try_link:hover{
  cursor: pointer;
  font-weight: 600;
}
.window_content.student{
  display: flex;
  justify-content: space-around;
  padding-top: 4vw;
}
.window_content.student>div>p{
  height: 4vw;
  line-height: 2vw;
}
.window_content.student>div>img{
  width: 10vw;
  height: 10vw;
}
.try_window.mandarin{
  padding-left: 26vw;
  text-align: left;
  background: url("../assets/images/mandarin_window_background.png");
  background-size: 100% 100%;
  color: white;
}
.try_window.mandarin>h1{
  font-size: 3vw;
  font-weight: 800;
}
.try_window.mandarin>h2{
  font-size: 1vw;
  font-weight: 600;
  line-height: 4vw;
}
.try_window.mandarin>p{
  font-size: 1.4vw;
  font-weight: 400;
}
.try_window.mandarin>img{
  width: 3vw;
  position: relative;
  left: 19vw;
  top: 2vw;
}
.try_window.mandarin>img:hover{
  cursor: pointer;
  transform: rotate(180deg);
  transition: all .3s ease;
}
.shuyuAI_download{
  display: flex;
  padding-top: 2vw;
}
.shuyuAI_download_btn{
  width: 10vw;
  height: 3vw;
  border: wheat 1px groove;
  line-height: 3vw;
  border-radius: 0.4vw;
  margin-bottom: 1.6vw;
}
.shuyuAI_download_btn>img{
  width: 2vw;
  height: 2vw;
  margin:0 1vw 0 0.5vw;
}
.shuyuAI_download_left{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 10vw;
  margin-right: 2vw;
}
.shuyuAI_download_left>h5{
  font-size: 1vw;
  font-weight: normal;
  padding-top: 6.6vw;
}
.shuyuAI_QR_code{
  width: 11vw;
  height: 11vw;
  border: gray 1px solid;
  border-radius: 1vw;
  background: white;
  box-shadow: 0.2vw 0.2vw 1vw grey;
}
.shuyuAI_QR_code>img{
  margin: 0.5vw 0 0 0.5vw;
  width: 10vw;
  height: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Cover.vue